// extracted by mini-css-extract-plugin
module.exports = {"root":"NotFound_root__1OSFs","content":"NotFound_content__1U3qA","buttons":"NotFound_buttons__1vncm"};